import React from 'react'
import Support from '../../Support/index'
import VerticalNavigation, { ACCOUNT } from '../../VerticalNavigation/index'
import MyAccountSettingsV2 from '../MyAccountSettingsV2/index'

const MyAccountSettings = ({ location }) => (
  <>
    <div className="my-account__grid">
      <VerticalNavigation location={location} navType={ACCOUNT} />
      <MyAccountSettingsV2 />
    </div>
    <div className="my-account-settings__support-container">
      <Support />
    </div>
  </>
)

export default MyAccountSettings
